/** @format */
import { React, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { GlobalProvider } from './context/GlobalState';
import Add from './component/Add';
import Watched from './component/Watched';
import './component/Add.css';
import Favouritemovies from './component/Favouritemovies';
import Header from './component/Header';
import { Nav } from 'react-bootstrap';
import { Loginscreen } from './screens/LoginScreen';
import { auth } from './firebase';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout, selectUser } from './features/userSlice';
function Searchtest() {
	const user = useSelector(selectUser);
	const dispatch = useDispatch();
	useEffect(() => {
		const unsbscribe = auth.onAuthStateChanged((userAuth) => {
			if (userAuth) {
				//login
				console.log(userAuth);
				dispatch(
					login({
						uid: userAuth.uid,
						email: userAuth.email,
					})
				);
			} else {
				//logout
				dispatch(logout());
			}
		});

		return unsbscribe;
	}, [dispatch]);

	return (
		<div className='ok'>
			<GlobalProvider>
				<Router>
					<Header />

					<Switch>
						<Route exact path='/Add'>
							<Add />
						</Route>

						<Route path='/favouritemovies'>
							<Favouritemovies />
						</Route>
						<Route path='/watched'>
							<Watched />
						</Route>
					</Switch>
				</Router>
			</GlobalProvider>
		</div>
	);
}

export default Searchtest;
